function videoPlaying() {
  return !!(
    this.currentTime() > 0 &&
    !this.paused() &&
    !this.ended() &&
    this.readyState() > 2
  );
}
export default videoPlaying;
